import { themedUseStyletron } from '../../../theme/customTheme'
import { IFireDamperOpenClose } from './types'
import { LabelLarge } from 'baseui/typography';
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'

// icons
import { MdAmpStories } from "react-icons/md";
import { FormattedMessage } from 'react-intl';

export function OverviewPanel(props: IFireDamperOpenClose) {
    const [, theme] = themedUseStyletron();

    return (
        <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} {...props}>
            <>
                <MdAmpStories color={props.isOpen ? theme.appColors.aggregate.on : props.isClose? theme.appColors.aggregate.error : theme.appColors.aggregate.off} size='40px' />
                {props.isOpen && <LabelLarge><FormattedMessage id="Devices.OPEN" defaultMessage="OPEN" /></LabelLarge>}
                {props.isClose && <LabelLarge color={theme.appColors.aggregate.error}>{<FormattedMessage id="Devices.CLOSED" defaultMessage="CLOSED" />}</LabelLarge>}
            </>

        </OverviewPanelWrapper>
    );
}